import {IStore} from "modules/types";
import {createSelector} from "reselect";
import {get} from "lodash";

export const getTeamStatistics = ({team_statistics}: IStore) => team_statistics;
export const getTeamStatisticsByIds = createSelector(
	getTeamStatistics,
	(statistics) => (home_id: string, away_id: string) => get(statistics, `${home_id}_${away_id}`, null)
);
